export function isValidContactPhone(phone) {
  return /^[+0-9 ()-]+$/.test(phone) && /^\d{9,15}$/.test(phone.replace(/\D/g, ""));
}
